const sha256 = require('js-sha256').sha256

export function GenerateHASH (originalstring) {
  var hash = sha256.create()
  hash.update(originalstring)
  return hash.hex()
}
